// extracted by mini-css-extract-plugin
export default {"PendingSkip":"NsYSbKYU","Content":"eu2JO09q"};